

export default function getCandidatureTrackingCategory(offreSource){
  let category = 'Unknown'
  if(offreSource === "GLOW") category = 'Goldenbees'
  else if (offreSource === "TALENTPLUG") category = 'Talentplug'
  return `candidature_offre_${category}`
}
